import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'search-graph-customer-org.customer-org-label',
		defaultMessage: 'Customer Organization',
		description: 'Customer Organization subtype label',
	},
});
